import Grade from 'src/local-logic/tip-match/wzry-info/index.js';
import { UserInfo } from '@tencent/pmd-tools/lib/user-info';

export function getTeamInfo(teaminfo) {
  const team = {};
  team.teamId = teaminfo.teamid;
  team.teamPic = teaminfo.teamavatar;
  team.teamName = teaminfo.teamname;
  team.captainUid = teaminfo.capuid;
  team.isCaptain = UserInfo.isUnion(teaminfo.capuid); // 我是否是队长
  team.teamType = teaminfo.teamtype;   // 队伍类型 1 '合作赛通道队伍'（默认队伍）, 2 '战队赛通道队伍', 3 '微赛事通道队伍'（已屏蔽）
  team.teamSlogan = teaminfo.selfdef && teaminfo.selfdef.teamsign ? teaminfo.selfdef.teamsign : '';
  team.memberNum = teaminfo.memnum || 0;
  team.memberNumMaxLimit = teaminfo.memmaxlimit || 0; // 队伍人数上限
  team.signedIndex = teaminfo.signup_id;
  team.members = teaminfo.members && teaminfo.members.length > 0 ? teaminfo.members : [];
  team.applyChildId = teaminfo.childid;
  team.isShowDelete = false;
  if (teaminfo.gamestatus === 1000 || teaminfo.gamestatus === 2000) {
    // 确认报名
    team.gameStatus = 2;
  } else if (teaminfo.gamestatus === 0) {
    // 预报名
    team.gameStatus = 1;
  } else {
    team.gameStatus = 0;
  }

  return team;
}

export function getTeamSimpleTakeMem({ teamSimpleTakeMem }) {
  const teamInfo = {};
  if (!teamSimpleTakeMem) {
    return teamInfo;
  }
  const teamInfoSimple = teamSimpleTakeMem.team_simple || {};
  if (teamInfoSimple) {
    teamInfo.teamId = teamInfoSimple.teamid;
    teamInfo.teamPic = teamInfoSimple.teamavatar; // 队伍头像
    teamInfo.teamName = teamInfoSimple.teamname;  // 队伍名称
    teamInfo.captainUid = teamInfoSimple.capuid;  // 队长uid
    teamInfo.isCaptain = UserInfo.isUnion(teamInfoSimple.capuid); // 我是否是队长
    teamInfo.signedIndex = teamInfoSimple.signup_id;  // 报名编号
  }
  teamInfo.memList = teamSimpleTakeMem.mem_list || []; // 队员列表
  return teamInfo;
}

export function parserTeamInfo(teamInfo) {
  const team = {};
  if (!teamInfo) {
    return team;
  }
  team.teamId = teamInfo.team_id;
  team.teamPic = teamInfo.team_logo; // 队伍头像
  team.teamName = teamInfo.team_name;  // 队伍名称
  team.campName = teamInfo.camp_name;  // 阵营名称
  team.signedIndex = teamInfo.version;  // 报名编号
  team.valid = teamInfo.team_valid;  // 是否解散，true：生效中 false:已经解散
  team.teamPrivateTag = teamInfo.audit_switch;  // 1：公开队伍，2：私密队伍
  team.confirmStatus = teamInfo.confirm_status; // 确认报名状态：100 已确认
  team.childName = teamInfo.child_name; // 赛事组织名称
  team.nLimit = teamInfo.n_limit; // 补充席位
  team.memNum = teamInfo.mem_num; // 默认席位
  team.memList = [];
  if (teamInfo.seat_list) {
    teamInfo.seat_list.forEach((seat) => {
      const showMember = {};
      if (seat.member_info) {
        showMember.uid = seat.member_info.uid;

        if (seat.member_info.member_info) {
          showMember.head = seat.member_info.member_info.head;
          showMember.nick = seat.member_info.member_info.nick;
        }

        if (seat.member_info.member_info.game_info) {
          showMember.gradeCnName = seat.member_info.member_info.game_info.gradeCnName;
          showMember.gradePic = seat.member_info.member_info.game_info.gradePic;

          Grade.forEach((item) => {
            if (item.Id === seat.member_info.member_info.game_info.gradeOfRank) {
              showMember.gradePic = item.Pic;
            }
          });
        }

        if (seat.member_info.is_cap === true) {
          team.captainUid = seat.member_info.uid;
          showMember.team_role = 1;
          team.captainInfo = showMember;
        } else {
          showMember.team_role = 2;
          team.memList.push(showMember);
        }
      }
    });
    team.memList = [team.captainInfo].concat(team.memList);
  }
  return team;
}

export function mockTeamInfo() {
  const team = {};
  team.teamId = `fdafadfdgdfadad${Math.random()}`;
  team.teamPic = 'https://dummyimage.com/96x96';
  team.teamName = '开发天团';
  team.captainUid = `7B542ECA3695E2521AEDDA537C6D19C4${Math.random()}`;
  team.isCaptain = true;
  team.teamType = 1;
  team.teamSlogan = '快来加入我们';
  team.memberNum = 5;
  team.memberNumMaxLimit = 7; // 队伍人数上限
  team.members = [
    {
      head: 'https://dummyimage.com/96x96',
      nick: '张三',
      teamrole: 1,
    },
    {
      head: 'https://dummyimage.com/96x96',
      nick: '李四',
      teamrole: 2,
    },
    {
      head: 'https://dummyimage.com/96x96',
      nick: '王八',
      teamrole: 2,
    },
    {
      head: 'https://dummyimage.com/96x96',
      nick: '李四',
      teamrole: 2,
    },
    {
      head: 'https://dummyimage.com/96x96',
      nick: '王八',
      teamrole: 2,
    },
  ];
  team.applyChildId = 321212;
  team.gameStatus = 1;
  return team;
}

export function getTeamTotal({ teamTotal }) {
  const teamInfo = {
    fullTeamNums: 0,
    notFullTeamNums: 0,
    teamNums: 0,
  };
  if (!teamTotal) {
    return teamInfo;
  }
  teamInfo.fullTeamNums = teamTotal.full_team_nums || 0;
  teamInfo.notFullTeamNums = teamTotal.not_full_team_nums || 0;
  teamInfo.teamNums = teamTotal.team_nums || 0;
  return teamInfo;
}

export function getFirstTeam({ firstTeam }) {
  const team = {
    rankType: 0,
    teamInfo: {},
  };
  if (!firstTeam) {
    return team;
  }
  team.rankType = firstTeam.rank_type || 0;
  team.teamInfo = getTeamSimpleTakeMem({ teamSimpleTakeMem: firstTeam.team_info });
  return team;
}

export function getRankList({ rank }) {
  const list = [];
  if (!rank) {
    return list;
  }
  for (let i = 0; i < rank.length; i++) {
    list.push({
      pic: rank[i].teamavatar,
      name: rank[i].teamname,
      id: rank[i].teamid,
    });
  }
  return list;
}

